import SsoForms from '../../components/ssoForms'

const MOUNT_SELECTOR = '#sso-forms-root'

const element = document.querySelector(MOUNT_SELECTOR)
new SsoForms({
  flow: element.dataset.flow,
  rootElement: MOUNT_SELECTOR,
  toggleElement: element.dataset.toggleElement,
  submitElement: element.dataset.submitElement,
  ssoClientKey: element.dataset.ssoClientKey,
  ssoServerDomain: element.dataset.ssoServerDomain,
  recaptchaSiteKey: element.dataset.recaptchaSiteKey,
  fullWidth: element.dataset.fullWidth === 'true'
}).renderForm()
